/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamClassStudentDropdownQueryResponse,
  GetApiV1ExamClassStudentDropdownQueryParams,
  GetApiV1ExamClassStudentDropdown400,
  GetApiV1ExamClassStudentDropdown401,
  GetApiV1ExamClassStudentDropdown500,
} from "../../types/examSharedController/GetApiV1ExamClassStudentDropdown.ts";

function getGetApiV1ExamClassStudentDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/class-student-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de turmas ativas para uso em componentes de seleção. Quando courseId é informado, filtra pelo curso. Quando companyId é informado, filtra pela empresa; caso contrário, se mainOnly for verdadeiro, retorna apenas turmas sem empresa associada. Quando monographOnly é verdadeiro, retorna apenas turmas de cursos com monografia. **(Requer Authorization para autenticação)**
 * @summary Lista de turmas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/class-student-dropdown}
 */
export async function getApiV1ExamClassStudentDropdown(
  params?: GetApiV1ExamClassStudentDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamClassStudentDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamClassStudentDropdown400
      | GetApiV1ExamClassStudentDropdown401
      | GetApiV1ExamClassStudentDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamClassStudentDropdownUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
